export const RESET_REDUX_STATE = 'RESET_REDUX_STATE';
export const UPDATE_ADMIN_STATE = 'UPDATE_ADMIN_STATE';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_LOADED = 'AUTH_LOADED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const TOKEN_VERIFYING = 'TOKEN_VERIFYING';
export const TOKEN_VERIFIED = 'TOKEN_VERIFIED';
export const TOKEN_VERIFICATION_FAILED = 'TOKEN_VERIFICATION_FAILED';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const CHANGE_AGENT_STATE = 'CHANGE_AGENT_STATE';
export const AGENT_STATE_UPDATED = 'AGENT_STATE_UPDATED';



// WEBPACK FOOTER //
// ./src/data/redux/admin_details/actiontypes.js